const Card = ({
  interaction,
  mode,
  editable,
  editedScores,
  loadingUpdate,
  handleScoreChange,
}) => {
  const scoreValue = String(interaction?.Score ?? '').split('.')[0];
  const date = interaction?.dateRegister?.split('T')[0] ?? '';

  if (mode === 'modal') {
    return (
      <li className="rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <h3 className="break-words text-base font-semibold text-gray-900">
              {interaction?.Name ?? ''}
            </h3>
            <p className="mt-1 break-words text-sm text-gray-500">
              {interaction?.type ?? ''}
            </p>
            {date && (
              <p className="mt-1 text-xs text-gray-500">
                Fecha: {date}
              </p>
            )}
          </div>
          <span className="inline-flex w-fit shrink-0 rounded-md border border-green-100 bg-green-50 px-3 py-1.5 text-sm font-semibold text-green-600">
            +{scoreValue} pts
          </span>
        </div>
      </li>
    );
  }

  if (mode === 'resume') {
    return (
      <li className="py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0">
            <h3 className="break-words text-sm font-semibold leading-tight text-gray-900">
              {interaction?.Name ?? ''}
            </h3>
            <p className="mt-1 break-words text-xs text-gray-500">
              {interaction?.type ?? ''}{date ? <>&nbsp;&bull;&nbsp;{date}</> : null}
            </p>
          </div>
          <span className="inline-flex w-fit shrink-0 rounded-md bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
            +{scoreValue} pts
          </span>
        </div>
      </li>
    );
  }

  return (
    <li className="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex flex-col gap-1">
          <h3 className="break-words text-sm font-semibold text-gray-800">
            {interaction?.Name ?? ''}
          </h3>
          {mode !== 'principal' && (
            <p className="break-words text-xs text-gray-500">
              {interaction?.type ?? ''}{date ? <>&nbsp;&bull;&nbsp;{date}</> : null}
            </p>
          )}
          {mode !== 'resume' && (
            <p className="mt-1 break-words text-[11px] leading-snug text-gray-600">
              {interaction?.type ?? ''}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-2 text-xs">
        {mode === 'principal' && 'Puntaje'}
        {editable ? (
          <input
            type="text"
            value={
              editedScores[interaction?.Id] !== undefined
                ? editedScores[interaction?.Id]
                : interaction?.Score
            }
            onChange={(e) => handleScoreChange(interaction?.Id, e.target.value)}
            className="ml-1 w-8 rounded border border-purple-500 bg-purple-100 px-2 py-1 text-center text-gray-600"
            disabled={loadingUpdate}
          />
        ) : (
          <span className="inline-flex flex-shrink-0 items-center rounded-full bg-purple-50 px-2 py-0.5 text-xs text-purple-700">
            Puntaje:
            <span className="ml-1 font-semibold">{scoreValue}</span>
          </span>
        )}
      </div>
    </li>
  );
};

export default Card;
